import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  goToContractor,
  goToContractors,
  loadContractorRequest,
  loadNewContractorParametersRequest,
  selectServiceArea,
  selectTrade,
  selectUnion,
  setW9Document,
  submitFormRequest,
  updateFormFromCurrentContractor,
  updateFormValue,
} from '../../../actions/admin/contractors/contractors';
import {
  getCurrentContractor,
  getForm,
  getInvalidFields,
  getSelectedServiceAreasId,
  getSelectedTradesId,
  getSelectedUnionsId,
  getW9Document,
  getServiceAreas,
  getTrades,
  getUnions,
  getValidationMessage,
} from '../../../selectors/admin/contractors/contractors';
import ContractorForm from './ContractorForm';

class NewContractor extends Component {
  constructor(props) {
    super(props);
    this.editContractor = false;
  }

  componentDidMount() {
    this.props
      .dispatch(
        loadNewContractorParametersRequest(
          this.props.serviceAreas,
          this.props.trades,
          this.props.unions
        )
      )
      .then(() => {
        if (this.props.match.params.hasOwnProperty('id')) {
          // Editing a contractor
          this.editContractor = true;
          if (this.props.currentContractor === null) {
            // If contractor not loaded, load it
            this.props
              .dispatch(loadContractorRequest(this.props.match.params.id))
              .then(() =>
                this.props.dispatch(
                  updateFormFromCurrentContractor(this.props.currentContractor)
                )
              );
          } else {
            this.props.dispatch(
              updateFormFromCurrentContractor(this.props.currentContractor)
            );
          }
        }
      });
  }

  handleServiceAreaSelection = (value) => {
    this.props.dispatch(selectServiceArea(value));
  };

  handleTradesSelection = (value) => {
    this.props.dispatch(selectTrade(value));
  };

  handleUnionSelection = (value) => {
    this.props.dispatch(
      selectUnion(value, this.props.unions, this.props.selectedUnionsId)
    );
  };

  handleW9DocumentChange = (file) => {
    this.props.dispatch(setW9Document(file));
  };

  handleFormChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleSubmit = (sendInvitation) => {
    const promise = this.props.dispatch(
      submitFormRequest(
        this.props.form,
        this.props.selectedServiceAreasId,
        this.props.selectedTradesId,
        this.props.selectedUnionsId,
        this.props.w9Document,
        sendInvitation,
        this.editContractor ? this.props.currentContractor.id : undefined
      )
    );
    if (promise !== null) {
      promise.then((response) => {
        if (response.ok) {
          if (this.editContractor) {
            this.props.dispatch(
              goToContractor(this.props.currentContractor.id)
            );
          } else {
            this.props.dispatch(goToContractors());
          }
        }
      });
    }
  };

  render() {
    return (
      <ContractorForm
        edit={this.editContractor}
        form={this.props.form}
        invalidFields={this.props.invalidFields}
        selectedServiceAreasId={this.props.selectedServiceAreasId}
        selectedTradesId={this.props.selectedTradesId}
        selectedUnionsId={this.props.selectedUnionsId}
        w9Document={this.props.w9Document}
        serviceAreas={this.props.serviceAreas}
        trades={this.props.trades}
        unions={this.props.unions}
        validationMessage={this.props.validationMessage}
        onFormChange={this.handleFormChange}
        onServiceAreaSelection={this.handleServiceAreaSelection}
        onSubmit={this.handleSubmit}
        onTradesSelection={this.handleTradesSelection}
        onUnionSelection={this.handleUnionSelection}
        onW9DocumentChange={this.handleW9DocumentChange}
      />
    );
  }
}

export default connect((state) => {
  return {
    currentContractor: getCurrentContractor(state),
    invalidFields: getInvalidFields(state),
    form: getForm(state),
    serviceAreas: getServiceAreas(state),
    selectedServiceAreasId: getSelectedServiceAreasId(state),
    selectedTradesId: getSelectedTradesId(state),
    selectedUnionsId: getSelectedUnionsId(state),
    w9Document: getW9Document(state),
    trades: getTrades(state),
    unions: getUnions(state),
    validationMessage: getValidationMessage(state),
  };
})(NewContractor);



// WEBPACK FOOTER //
// ./src/components/admin/contractors/NewContractor.js